// 📁 Imports

// 💾 Variables
const alertsCloseButton = document.querySelectorAll("[data-alert-close]");
const showClass = "alert--state-show";

// 📐 Functions
const alertShow = (el, message) => {
  const content = el.querySelector("[data-alert-contnet]");
  if (message && content) {
    // Handle different message formats
    let messageText = "";
    
    if (typeof message === "string") {
      messageText = message;
    } else if (typeof message === "object") {
      // Handle server response format: { error: ["message1", "message2"] }
      if (message.error && Array.isArray(message.error)) {
        messageText = message.error.join("<br>");
      } else if (message.success && Array.isArray(message.success)) {
        messageText = message.success.join("<br>");
      } else if (Array.isArray(message)) {
        messageText = message.join("<br>");
      } else {
        messageText = JSON.stringify(message);
      }
    }
    
    content.innerHTML = messageText;
  }
  el.classList.add(showClass);
};

const alertHide = (el) => {
  el.classList.remove(showClass);
};

// 🖱️ Event listener
if (alertsCloseButton.length !== 0) {
  Array.from(alertsCloseButton).forEach((button) => {
    const alertWrapper = button.closest("[data-alert]");
    alertWrapper.addEventListener("click", () => {
      alertHide(alertWrapper);
    });
  });
}

// 📤 Export
export { alertShow, alertHide };
